if (!customElements.get('regular-subscription-selector')) {
  customElements.define('regular-subscription-selector', class RegularSubscriptionSelector extends HTMLElement {
    constructor() {
      super();
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.variantInput = this.productForm?.querySelector('input[name="id"]');
      this.sellingPlanInput = this.querySelector('[data-regular-selling-plan-input]');
      this.oneTimeOption = this.querySelector('[data-regular-one-time-option]');
      this.oneTimeInput = this.querySelector('[data-regular-one-time]');
      this.planOptions = this.querySelector('[data-regular-plan-options]');
      this.selectedPlanId = new URLSearchParams(window.location.search).get('selling_plan') || '';
      this.selectionMode = this.selectedPlanId ? 'subscription' : 'one-time';
      this.plans = Array.from(this.querySelectorAll('[data-regular-plan]'))
        .map((plan) => ({
          variantId: String(plan.dataset.variantId),
          sellingPlanId: plan.dataset.sellingPlanId,
          sellingPlanGroupId: plan.dataset.sellingPlanGroupId,
          name: plan.dataset.planName,
          price: plan.dataset.price,
          compareAtPrice: plan.dataset.compareAtPrice
        }))
        .filter((plan) => plan.sellingPlanGroupId === this.dataset.regularGroupId);

      this.planOptions?.addEventListener('change', this.onPlanChange.bind(this));
      this.oneTimeInput?.addEventListener('change', this.onOneTimeChange.bind(this));
      this.variantInput?.addEventListener('change', this.onVariantChange.bind(this));
    }

    connectedCallback() {
      this.renderForVariant(this.variantInput?.value);
    }

    onVariantChange(event) {
      this.renderForVariant(event.target.value);
    }

    onOneTimeChange(event) {
      if (!event.target.checked) return;
      this.selectionMode = 'one-time';
      this.selectedPlanId = '';
      this.updateSellingPlan('');
    }

    onPlanChange(event) {
      if (!(event.target instanceof Element)) return;
      const selectedPlan = event.target.closest('[data-regular-plan-choice]');
      if (!(selectedPlan instanceof HTMLInputElement) || !selectedPlan.checked) return;
      this.selectionMode = 'subscription';
      this.selectedPlanId = selectedPlan.value;
      this.updateSellingPlan(this.selectedPlanId);
    }

    getPlansForVariant(variantId) {
      return this.plans.filter((plan) => plan.variantId === String(variantId));
    }

    renderForVariant(variantId) {
      const plans = this.getPlansForVariant(variantId);
      const selectedPlanIsAvailable = plans.some((plan) => plan.sellingPlanId === this.selectedPlanId);
      const canPurchaseOneTime = Boolean(this.oneTimeInput);

      if (!selectedPlanIsAvailable) {
        this.selectedPlanId = this.selectionMode === 'subscription' && plans.length > 0
          ? plans[0].sellingPlanId
          : '';
      }

      if (!canPurchaseOneTime && !this.selectedPlanId && plans.length > 0) {
        this.selectionMode = 'subscription';
        this.selectedPlanId = plans[0].sellingPlanId;
      }

      this.renderPlanOptions(plans);
      const useSubscription = this.selectionMode === 'subscription' && this.selectedPlanId;

      if (this.oneTimeInput) this.oneTimeInput.checked = !useSubscription;
      this.updateSellingPlan(useSubscription ? this.selectedPlanId : '');
    }

    renderPlanOptions(plans) {
      if (!this.planOptions) return;

      this.planOptions.replaceChildren(...plans.map((plan) => {
        const label = document.createElement('label');
        label.className = 'regular-subscription-selector__option';

        const input = document.createElement('input');
        input.className = 'regular-subscription-selector__radio';
        input.type = 'radio';
        input.name = `regular-purchase-option-${this.dataset.sectionId}`;
        input.value = plan.sellingPlanId;
        input.checked = this.selectionMode === 'subscription' && plan.sellingPlanId === this.selectedPlanId;
        input.dataset.regularPlanChoice = '';

        const control = document.createElement('span');
        control.className = 'regular-subscription-selector__radio-control';
        control.setAttribute('aria-hidden', 'true');

        const content = document.createElement('span');
        content.className = 'regular-subscription-selector__option-content';

        const title = document.createElement('span');
        title.className = 'regular-subscription-selector__option-title';
        title.textContent = plan.name;
        content.append(title);

        if (plan.price) {
          const price = document.createElement('span');
          price.className = 'regular-subscription-selector__option-price';
          price.textContent = plan.price;
          content.append(price);
        }

        label.append(input, control, content);
        return label;
      }));
    }

    updateSellingPlan(sellingPlanId) {
      if (!this.sellingPlanInput) return;
      this.sellingPlanInput.value = sellingPlanId;
      this.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}
